function _setPrototypeOf(t,e){return _setPrototypeOf=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},_setPrototypeOf(t,e)}

export { _setPrototypeOf as default };
//# sourceMappingURL=setPrototypeOf.js.map
